var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTick(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15.9207,
    cy: 15.0491,
    r: 8.47682,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5758 2.6582C9.39007 2.6582 3.53455 8.51373 3.53455 15.6995C3.53455 22.8852 9.39007 28.7407 16.5758 28.7407C23.7616 28.7407 29.6171 22.8852 29.6171 15.6995C29.6171 8.51373 23.7616 2.6582 16.5758 2.6582ZM22.8095 12.7L15.4151 20.0944C15.2326 20.277 14.9848 20.3813 14.724 20.3813C14.4631 20.3813 14.2153 20.277 14.0328 20.0944L10.3421 16.4037C9.96389 16.0255 9.96389 15.3995 10.3421 15.0213C10.7203 14.6431 11.3463 14.6431 11.7245 15.0213L14.724 18.0208L21.4272 11.3176C21.8054 10.9394 22.4313 10.9394 22.8095 11.3176C23.1877 11.6958 23.1877 12.3087 22.8095 12.7Z",
    fill: "#56B934"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTick);
export default __webpack_public_path__ + "static/media/tick.51628aa701e82a992dce5b15326d96c8.svg";
export { ForwardRef as ReactComponent };